import { styled as t } from "styled-components";
import { MediaQuery as e } from "../../../../styles/variables.js";
import { DealButtonSkeleton as i } from "../../DealButton/style.js";
const a = t.div`
  grid-area: action;
  margin-top: 16px;

  > div {
    display: flex;
    align-items: center;
  }
`, l = t.div`
  display: flex;
  align-items: center;
`, p = t(i)`
  width: 34px;
  height: 34px;
`, m = t(i)`
  width: 175px;
  margin-right: auto;
  height: 36px;

  @media ${e.SCREEN_MD_UP} {
    margin-right: 16px;
  }
`;
export {
  a as ActionsSkeleton,
  l as FollowSkeletonContainer,
  m as NotificationSkeleton,
  p as SaveSkeleton
};
